import { createFileRoute, redirect } from '@tanstack/react-router';
import type { StyleDetail } from '@/api/my-styles/types';
import { DppWebshopPreviewTab } from '@/app/(client)/my-styles/-components/DppWebshopPreviewTab';
import {
  isEntityKindPath,
  useEntityDetail,
} from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/webshop-preview',
)({
  beforeLoad: async ({ params }) => {
    const perms = await ensurePermissions();
    if (!perms['digital-products-passport'].canRead) {
      throw redirect({
        to: '/my-styles/$kind/$id/overview',
        params: {
          kind: isEntityKindPath(params.kind) ? params.kind : 'styles',
          id: params.id,
        },
      });
    }

    // Webshop preview only exists for styles. For variants/skus, send the user
    // back to the kind's overview tab.
    if (!isEntityKindPath(params.kind) || params.kind !== 'styles') {
      throw redirect({
        to: '/my-styles/$kind/$id/overview',
        params: {
          kind: isEntityKindPath(params.kind) ? params.kind : 'styles',
          id: params.id,
        },
      });
    }
  },
  component: DppWebshopPreviewRoute,
});

function DppWebshopPreviewRoute() {
  const { id } = Route.useParams();
  const { data: entity } = useEntityDetail('styles', id);
  return (
    <DppWebshopPreviewTab
      styleId={id}
      style={entity as StyleDetail | null | undefined}
    />
  );
}
